<template>
  <div class="PageBtn">
      <div class="left" v-if="this.pageinfo.pageNum > 1" @click="pageTurning('sub')">
        <i class="el-icon-caret-left"></i>
        <span>上一页</span>
      </div>    
      <div class="left error-btn" v-else>
        <i class="el-icon-caret-left"></i>
        <span>上一页</span>
      </div>  

      <div class="right" v-if="this.pageinfo.pageNum < this.pageinfo.pageCount" @click="pageTurning('add')">
          <span>下一页</span>
          <i class="el-icon-caret-right"></i>
      </div>
      <div class="right error-btn" v-else>
          <span>下一页</span>
          <i class="el-icon-caret-right"></i>
      </div>
  </div>
</template>

<script>
import merge from 'webpack-merge'
export default {
  name: 'PageBtn',
  props: ['pageinfo', 'examstatus'], //pageinfo:{pageCount 最大页数 pageNum 当前页数 pageSize 每页显示条数 rowCount 题目总数} examstatus 试卷提交状态
  data () {
    return {
        page: 0
    }
  },
  mounted () {},
  methods: {
    pageTurning(type) {   // 翻页
        this.page = parseInt(this.$route.query.page)
        if (type == 'add') {
            this.page += 1
        } else if (type == 'sub') {
            this.page -= 1
        }

        
        
        // 试卷已经提交状态下，不需要再次提交内容
        if (this.examstatus == 1) {
            this.$router.push({
                query: merge(this.$route.query, {'page': this.page})
            })
        } else {
            // 翻页前需提交当前页面的考试信息
            let answerList = this.$parent.$parent._combinationExaminationAontent()
            // 回调考试接口
            this.$parent.$parent.CallbackSaveExamRecord(answerList, () => {
                this.$router.push({
                    query: merge(this.$route.query, {'page': this.page})
                })
            })
        }


    }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.PageBtn {
    padding: 0 265px;
    margin-top: 30px;
    height: 60px;
    line-height: 60px;
    background: #fff;

    span {
        font-size: 16px;
    }
    i {
        font-size: 30px;
        display: inline-block;
        vertical-align: -6px;
    }

    .left {
        float: left;
        cursor: pointer;
    }
    .right {
        float: right;
        cursor: pointer;
    }
    .left,
    .right {
        &:hover {
            i,span {
                color: #409EFF;
            }
        }
        &.error-btn {
            cursor: not-allowed
        }
    }
}
</style>
